import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import SpecialPage from "@/pages/special/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:type",
    element: <CategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/news/detail/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/special",
    element: <SpecialPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;